import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

import { VerrouPosteAdmin } from '../../services/verrou-poste';

/**
 * Le bouton « Verrouiller le poste » de la barre du haut.
 *
 * Sans NIP il n'y aurait rien pour deverrouiller : on explique pourquoi et on ouvre la creation du NIP
 * (le dialogue existant) plutot que d'enfermer la personne dehors.
 */
export class TopbarVerrouCollab {
  constructor(
    private verrou: VerrouPosteAdmin,
    private translate: TranslateService,
    private messageService: MessageService,
    private creerNip: () => Promise<void>,
  ) {}

  async verrouiller(closeAll: () => void): Promise<void> {
    closeAll();
    const resultat = await this.verrou.verrouiller();
    if (resultat === 'sans-nip') {
      this.messageService.add({
        severity: 'info',
        summary: this.translate.instant('VERROU.NO_PIN') as string,
        life: 6000,
      });
      await this.creerNip();
    } else if (resultat === 'en-attente') {
      this.messageService.add({
        severity: 'info',
        summary: this.translate.instant('VERROU.PENDING') as string,
        life: 5000,
      });
    }
  }
}
